<template>
  <div class="dashboard-container">
    <div v-if="isLoading" class="loading-overlay">
      <div class="loader">
        <div class="loader-container">
          <span class="one"></span>
          <span class="two"></span>
          <span class="three"></span>
          <span class="four"></span>
        </div>
    <div class="Loading-text">
      Loading... Please Wait
      </div>
    </div>
    </div>
    <!-- Main Content -->
    <main class="main-content" v-if="!kibanaUrl"> 
      <h1 class="welcome-text">Welcome, Admin</h1>
      <!-- Table -->
       <div class = "table-container"
        :class="{ 'table-shrink': showFolderDrawer  }">
        <table class="user-table">
          <thead>
            <tr>
              <th>
              <input
                type="checkbox"
                v-model="selectAll"
                @change="toggleSelectAll"
              />
              </th>
              <th>Clinic Name</th>
            <!-- <th>Link URL</th> -->
              <th>Users</th>
              <th>Stats</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="clinic in clinics" :key="clinic.id">
              <td>
                <input
                  type="checkbox"
                  :checked="selectedClinics.includes(clinic.clinicLinkId)"
                  @change="toggleSelectClinic(clinic.clinicLinkId)"
                />
              </td>
            <td>{{ clinic.name??"Loading..." }}</td>
            <td>{{ usersByLink[clinic.clinicLinkId] 
              ? usersByLink[clinic.clinicLinkId].filter(u => u.active).length : 'Loading...' }}</td>
            <td @click="openStats(clinic)" style="cursor: pointer;">{{ "Show stats"??"Loading..." }}</td>
            <td><i class="fas fa-plus action-icon edit" 
                  style="color:#3498db; cursor:pointer"
             @click="addtofolder(clinic)"></i></td>
            <!-- <td>{{ clinic.stats??"-" }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Drawer -->
      <div v-if="this.selectedClinics.length > 0" class="drawer-overlay">
        <div class="drawer">
          <!-- Header -->
          <div class="drawer-header">
            <div class="header-left">
              <span v-if="breadcrumbPath.length > 0" class="back-icon" @click="goBack">
                <svg xmlns="http://www.w3.org/2000/svg"
                    width="24" height="24"
                    viewBox="0 0 24 24"
                    fill="none" stroke="white" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                    class="back-icon">
                  <circle cx="12" cy="12" r="11" stroke="white"/>
                  <polyline points="12 8 8 12 12 16"/>
                  <line x1="16" y1="12" x2="8" y2="12"/>
                </svg>
              </span>
              <span class="breadcrumb">
              {{ breadcrumbPath.length > 0 ? "Categories: Root > " + breadcrumbPath.map(b => b).join(" > ") : "Categories: Root" }}
              </span>
            </div>
            <span class="close-icon" @click="closeDrawer">
              <svg xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24"
                  viewBox="0 0 24 24"
                  fill="none" stroke="white" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"
                  class="close-icon">
                <circle cx="12" cy="12" r="11" stroke="white"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
            </span>
          </div>

          <!-- Content -->
          <div class="drawer-content">
            <div v-if="error" class="error-message">
              Error: {{ error }}
            </div>
            <div v-if="loading" class="loading-message">
              Loading folders...
            </div>

            <div v-else>
              <div class="folder-option" @click="createNewFolder">
                + Create New {{ breadcrumb.length === 1 ? 'Folder' : 'Sub Folder' }}
              </div>
              <div
                v-for="folder in getCurrentClinicsAndFolders"
                :key="folder.type === 'folder' ? folder.data.folderId : folder.data.id"
                class="folder-item"
                @click="folder.type === 'folder' ? openFolder(folder): undefined"
              >
              <!-- {{ folder.type === 'folder' ? "📁 " + folder.data.folderName : "🏥 " + folder.data.clinicName }} -->
              {{ folder.type === 'folder' ? "📁 " + folder.data.folderName : " "}}
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="drawer-footer">
  <!-- Show only if inside a folder -->
  <button 
    v-if="breadcrumbPath.length > 0" 
                    class="add-btn"
    @click="confirmAdd"
  >
              Add to this folder
            </button>

            <button class="cancel-btn" @click="closeDrawer">Cancel</button>
          </div>
        </div>
      </div>

<div v-if="showFolderModal" class="modal-overlay">
        <div class="modal">
          <h2>Create Folder</h2>
          <div class="form-group">
            <label>
              <input
                type="radio"
                value="new"
                v-model="folderOption"
              />
              Create New Folder
            </label>
            <label>
              <input
                type="radio"
                value="existing"
                v-model="folderOption"
              />
              Add to Existing Folder
            </label>
          </div>


          <div v-if="folderOption === 'new'" class="form-group">
            <label>New Folder Name:</label>
            <input type="text" v-model="newFolderName" placeholder="Enter folder name" />
    </div>


          <div v-if="folderOption === 'existing'" class="form-group">
            <label>Select Folder:</label>
            <select v-model="selectedFolder">
              <option disabled value="">-- Select Folder --</option>
              <option v-for="folder in folders" :key="folder.id" :value="folder.id">
                {{ folder.name }}
              </option>
            </select>
          </div>


          <div class="form-group">
            <label>Sub Folder:</label>
            <select v-model="subFolderOption">
              <option value="">-- None --</option>
              <option v-for="sub in existingSubFolders" :key="sub.id" :value="sub.id">
                {{ sub.name }}
              </option>
              <option value="new">+ Create New Sub Folder</option>
            </select>
          </div>


          <div v-if="subFolderOption === 'new'" class="form-group">
            <label>New Sub Folder Name:</label>
            <input type="text" v-model="newSubFolderName" placeholder="Enter sub folder name" />
          </div>

          <div class="modal-buttons">
            <button class="save-btn" @click="createFolder">Save</button>
            <button class="cancel-btn" @click="closeFolderModal">Cancel</button>
          </div>
        </div>
      </div>
      <div v-if="showNewFolderModal" class="modal-overlay">
        <div class="modal">
          <h2>Enter New Folder Name</h2>
          <input
            type="text"
            v-model="tempFolderName"
            placeholder="Folder name"
            class="modal-input"
          />
          <div class="modal-buttons">
            <button class="save-btn" @click="saveNewFolder">Save</button>
            <button class="cancel-btn" @click="showNewFolderModal = false">Cancel</button>
          </div>
        </div>
      </div>
      <!-- Duplicate Clinics Modal -->
      <div v-if="showDuplicateClinicModal" class="modal-overlay">
        <div class="modal">
          <h2>Duplicate Clinics Found</h2>
          <p>{{ duplicateClinics.length }} clinic(s) already exist in this folder:</p>

          <!-- Scrollable list -->
          <ul style="max-height:100px; overflow-y:auto; margin:10px 0; padding-left:20px;">
            <li v-for="clinic in duplicateClinics" :key="clinic.clinicLinkId">
              {{ clinic.name }}
            </li>
          </ul>

          <div class="modal-buttons">
            <button class="save-btn" @click="skipDuplicates">Skip All Duplicates</button>
            <button class="cancel-btn" @click="cancelDuplicateModal">Cancel</button>
          </div>
        </div>
      </div>
    </main>
    <div v-if="kibanaUrl">
      <KibanaIframe :src="kibanaUrl" @close="closeKibanaIframe" />
    </div>
    <div v-if="popup.show" :class="['popup', popup.type]">
      {{ popup.message }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KibanaIframe from "@/views/KibanaIframe.vue";
import { generateSingleClinicIdDashboardLink } from "@/utils";
export default {
  name: "DashboardView",
  components: {
    KibanaIframe,
  },
  data() {
    return {
      kibanaUrl: "",   // now used by KibanaIframe component
      isLoading: true,
      showSettingsDropdown: false,
      newUser: {
        email: "",
        password: "",
      },
      selectedClinics: [], // store selected clinic IDs
      selectAll: false,
      showFolderModal: false,
      folderOption: "new",
      newFolderName: "",
      selectedFolder: "",
      subFolderOption: "",
      newSubFolderName: "",
      // showFolderDrawer: false,
      breadcrumb: [{ id: null, name: "Categories" }],
      popup: {
        show: false,
        message: "",
      type: "" // success | error | info
      },
      tempFolderName: "",
      showNewFolderModal: false,
      showDuplicateClinicModal: false,
      duplicateClinics: [],
    };
  },
  async mounted() {
    try {
      await Promise.all([
        this.$store.dispatch("getClinics"),
        this.$store.dispatch("folderClinic/fetchFolderStructure"),
      ]);
    } catch (error) {
      console.error("Failed to load data:", error);
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters(["clinics", "usersByLink", "folders", "getAdminId"]),
    ...mapGetters("folderClinic", ["loading", "error", "folderStructure", "getCurrentClinicsAndFolders", "getCurrentFolderPath", "getCurrentFolder"]),
    currentFolders() {
      const parentId = this.breadcrumb[this.breadcrumb.length - 1].id;
      return this.$store.getters["folderClinic/foldersByParent"](parentId);
    },
    breadcrumbPath() {
      return this.getCurrentFolderPath?.split("/") ?? [];
    },
    showFolderDrawer() {
      return this.selectedClinics.length > 0;
    },
  },
  methods: {
    showPopup(message, type = "info") {
      this.popup.message = message;
      this.popup.type = type;
      this.popup.show = true;
      setTimeout(() => (this.popup.show = false), 3000);
    },

    generateKibanaUrl(clinicLinkId) {
      return generateSingleClinicIdDashboardLink(clinicLinkId);
    },

    collectClinicIds(folderItem) {
      let ids = [];
      const traverse = (item) => {
        if (item.type === "clinic") {
          if (item.data?.clinicLinkId) ids.push(item.data.clinicLinkId);
        }
        if (item.children?.length) item.children.forEach(traverse);
      };
      traverse(folderItem);
      return ids;
    },

    openStats(clinic) {
      if (!clinic?.clinicLinkId) return;

      this.kibanaUrl = this.generateKibanaUrl(clinic.clinicLinkId);

      this.$nextTick(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      });
    },

    closeKibanaIframe() {
      this.kibanaUrl = "";
    },
    handleCSVUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.showPopup(`CSV file "${file.name}" uploaded successfully!`, "success");
      }
    },
    toggleSelectAll() {
      this.selectedClinics = this.selectAll
        ? this.clinics.map((c) => c.clinicLinkId)
        : [];
    },
    openFolderModal() {
      this.showFolderModal = true;
    },
    closeFolderModal() {
      this.selectedClinics = [];
    },
    async createFolder() {
      try {
        let folderName, parentFolderId;

        if (this.folderOption === "new") {
          folderName = this.newFolderName;
          parentFolderId = this.subFolderOption === "new" ? null : this.subFolderOption;
        } else {
          folderName = this.selectedFolder;
          parentFolderId = this.subFolderOption === "new" ? null : this.subFolderOption;
        }

        if (this.subFolderOption === "new" && this.newSubFolderName) {
          folderName = this.newSubFolderName;
          parentFolderId = this.selectedFolder;
        }

        console.log("Folder Name:", this.getCurrentFolder);
        // await this.$store.dispatch("folderClinic/createFolder", {
        //   folderName,
        //   parentFolderId: this.getCurrentFolder?.folderId ?? null
        // });
        
        // If there are clinics to assign, assign them
        

        console.log("Folder Created:", { folderName, parentFolderId });
        this.showPopup("Folder created successfully!", "success");
        this.closeFolderModal();
      } catch (error) {
        console.error("Failed to create folder:", error);
        this.showPopup("Failed to create folder.", "error");
      }
    },
    addtofolder(clinic) {
  // store selected clinic object
      this.selectedClinics = [clinic.clinicLinkId];
      this.showFolderDrawer = true;
      this.breadcrumb = [{ id: null, name: "Categories" }];
    },
    toggleSelectClinic(clinicId) {
      if(this.selectedClinics.includes(clinicId)) {
        this.selectedClinics = this.selectedClinics.filter(id => id !== clinicId);
      } else {
        this.selectedClinics.push(clinicId);
      }
    },
    closeDrawer() {
      this.selectedClinics = [];
      this.showFolderDrawer = false;
      this.showNewFolderModal = false;
    },
    goBack() {
      this.$store.commit("folderClinic/SET_CURRENT_FOLDER_PATH", this.breadcrumbPath.length > 1 ? this.breadcrumbPath.slice(0, -1).join("/") : null);
    },
    openFolder(folder) {
      this.$store.commit("folderClinic/SET_CURRENT_FOLDER_PATH", this.getCurrentFolderPath ? this.getCurrentFolderPath + "/" + folder.data.folderName : folder.data.folderName);
    },
    async createNewFolder() {
      // reset temp state before opening modal
      this.tempFolderName = "";
      this.showNewFolderModal = true;
    },
    async saveNewFolder() {
      const folderNameTrimmed = this.tempFolderName.trim();
      if (!folderNameTrimmed) {
        this.showPopup("Folder name cannot be empty", "error");
        return;
      }
      // Get existing folders/subfolders in the current folder
      const existingFolders = this.getCurrentClinicsAndFolders?.filter(f => f.type === "folder") || [];
      // Check if a folder/subfolder with the same name already exists (case-insensitive)
      const duplicate = existingFolders.some(
        f => f.data.folderName.toLowerCase() === folderNameTrimmed.toLowerCase()
      );
      if (duplicate) {
        this.showPopup("A folder or subfolder with this name already exists.", "error");
        return;
      }
      try {
        await this.$store.dispatch("folderClinic/createFolder", {
          folderName: folderNameTrimmed,
          parentFolderId: this.getCurrentFolder?.folderId ?? null
        });
        this.showPopup("Folder created successfully!", "success");
        this.showNewFolderModal = false;
      } catch (error) {
        console.error("Failed to create folder:", error);
        this.showPopup("Failed to create folder. Please try again.", "error");
      }
    },
    async confirmAdd() {
      try {
        const clinicLinkIds = this.selectedClinics
          .filter(c => c)
          .map(c => (typeof c === "object" ? c.clinicLinkId : c));
        const contents = this.getCurrentClinicsAndFolders || [];
        const existingClinics = contents.filter(item => item.type === "clinic");
        const existingClinicIds = existingClinics.map(c => c.data.clinicLinkId || c.data.id);

        // find duplicates with clinic names
        const duplicates = clinicLinkIds
          .map(id => this.clinics.find(c => c.clinicLinkId === id))
          .filter(clinic => existingClinicIds.includes(clinic.clinicLinkId));
        if (duplicates.length > 0) {
          this.duplicateClinics = Array.from(
          new Map(duplicates.map(c => [c.clinicLinkId, c])).values()
          );
          this.showDuplicateClinicModal = true; // show modal
          return;
        }

        // no duplicates, proceed directly
        await this.addClinics(clinicLinkIds);
      } catch (error) {
        console.error("Failed to assign clinics:", error);
        this.showPopup("Failed to assign clinics to selected folder.", "error");
      }
    },

    async addClinics(clinicLinkIds) {
      const payload = {
        folderId: this.getCurrentFolder?.folderId ?? null,
        clinicLinkIds,
        clinicNames: clinicLinkIds.map(id => {
          const clinic = this.clinics.find(c => c.clinicLinkId === id);
          return clinic?.name || id;
        })
      };
      await this.$store.dispatch("folderClinic/addClinicsToFolder", payload);
      this.showPopup(`Added ${clinicLinkIds.length} clinic(s) to folder`, "success");
      this.closeDrawer();
    },

    skipDuplicates() {
      const duplicateIds = this.duplicateClinics.map(c => c.clinicLinkId);
      const filteredIds = this.selectedClinics.filter(
        id => !duplicateIds.includes(typeof id === "object" ? id.clinicLinkId : id)
      );

      this.showDuplicateClinicModal = false;

      if (filteredIds.length === 0) {
        this.showPopup("No clinics were added (all selected clinics are already in this folder).", "info");
        this.closeDrawer();
        return;
      }

      this.addClinics(filteredIds);
    },

    cancelDuplicateModal() {
      this.showDuplicateClinicModal = false;
      this.closeDrawer(); // abort flow
    },
  },
  watch: {
    clinics: {
      handler(newVal) {
      // Empty clinic list is a valid end state (greenfield DB) — do not spin forever
      if (!newVal || newVal.length === 0) {
        this.isLoading = false;
        return;
      }
      // Only treat placeholder clinic names as still loading.
      // Missing usersByLink entries mean "0 users", not infinite spinner.
        const stillLoading = newVal.some(
        c => !c.name || c.name === "Loading..."
        );

        this.isLoading = stillLoading;
      },
    },
    usersByLink: {
      handler() {
        if (!this.clinics || this.clinics.length === 0) {
          this.isLoading = false;
          return;
        }
        const stillLoading = this.clinics.some(
          c => !c.name || c.name === "Loading..."
        );
        this.isLoading = stillLoading;
      },
    },
    selectedClinics(val) {
      this.selectAll = val.length === this.clinics.length;
      this.showFolderDrawer = val.length > 0;
    }
  },
};
</script>

<style scoped>
.dashboard-container {
  display: flex;
  height: 100vh;
  background-image: url("@/assets/login-bg-desktop.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw; /* Full viewport width */
  height: 100vh; /* Full viewport height */
  /* background: rgba(0, 0, 0, 0.7); Semi-transparent black */
  backdrop-filter: blur(8px);
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure it's on top */
  color: white;
}

.Loading-text{
  padding-top: 20px;
}

.loader {
  width: 100%;
  height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loader-container {
  position: relative;
  width: 80px;
  height: 80px;
  span {
    position: absolute;
    display: block;
    width: 40%;
    height: 40%;
    border-radius: 50%;
    animation: speed 2s infinite ease-in-out;
    border: 2px solid #fff;
  }
  .one {
    background: #5bb9eb;
    animation-delay: 1.5s;
  }
  .two {
    background: #79eae1;
    animation-delay: 1s;
  }
  .three {
    background: #003e58;
    animation-delay: 0.5s;
  }
  .four {
    background: #f72a85;
  }
}
@keyframes speed {
  0% {
    transform: translate(0%);
    border-radius: 50%;
  }
  25% {
    transform: translate(150%) scale(0.5);
    border-radius: 0%;
  }
  50% {
    transform: translate(150%, 150%);
    border-radius: 50%;
  }
  75% {
    transform: translate(0, 150%) scale(0.5);
    border-radius: 0%;
  }
}

/* Main Content */
.main-content {
  flex: 1;
  padding: 20px;
  position: relative;
}
@media (max-width: 768px) {  /* Mobile */
  .main-content {
    display: inline-grid;
  }
}
.welcome-text {
  margin-bottom: 20px;
}


.add-user-btn {
  padding: 8px 16px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  margin-bottom: 2.4%;
}

.add-user-btn:hover {
  background: #2980b9;
}

/* Table */
.table-container {
  max-height: 80%; 
  overflow-y: auto;  
  overflow-x: auto;
  border-radius: 12px;
  transition: max-height 0.3s ease;
}
.table-container.table-shrink {
  height: 38%;
  max-height: 38%; /* reduce height when modal is open */
}
.user-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 12px;
  background: white;
  transition: max-height 0.3s ease;
}


.user-table th {
  position: sticky;
  top: 0;
  background-color: #3498db;
  color: white;
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #ddd;
}
.user-table td {
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

/* Modal */
.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 400px;
}

.upload-section {
  margin-bottom: 15px;
}

.or-text {
  text-align: center;
  margin: 10px 0;
  font-weight: bold;
}

.form-group {
  margin-bottom: 15px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.save-btn {
  padding: 8px 16px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.save-btn:hover {
  background: #2c3e50;
}

.cancel-btn {
  padding: 8px 16px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-btn:hover {
  background: #c0392b;
}
/* Drawer overlay */
.drawer-overlay {
  position: absolute;
  overflow-y: scroll;
  bottom: 0;
  border-radius: 12px;
  right: 0;
  width: 98%;
  margin-right: 1%;
  height: 50%;
  background-image: url("@/assets/login-bg-desktop.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: -2px 0 10px rgba(0,0,0,0.2);
  z-index: 1000;
  display: flex;
  flex-direction: column;
   scrollbar-width: thin;
  scrollbar-color: #3498db transparent;
}

/* Drawer header */
.drawer-header {
  display: flex;
  align-items: center;
  color: white;
  padding: 10px;
  background: #2980b9;
  border-bottom: 1px solid #ddd;
  justify-content: space-between;
}
.back-icon {
  margin-right: 10px;
  cursor: pointer;
}
.breadcrumb {
  font-size: 14px;
  color: #fff;;
}

.header-left {
  display: flex;
  align-items: center; /* vertically align icon + text */
  gap: 8px;            /* add spacing between arrow and text */
}

.close-icon {
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  transition: color 0.2s;
}

/* Drawer content */
.drawer-content {
  flex: 1;
  padding: 15px;
}
/* Chrome, Edge, Safari */
.drawer-overlay::-webkit-scrollbar {
  width: 8px;   /* thin like the dropdown */
}

.drawer-overlay::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.drawer-overlay::-webkit-scrollbar-thumb:hover {
  background-color: #2980b9; /* slightly darker on hover */
}

.folder-option {
  font-weight: bold;
  color: #3498db;
  margin-bottom: 15px;
  cursor: pointer;
}
.folder-item {
  padding: 8px 0;
  cursor: pointer;
}

/* Drawer footer */
.drawer-footer {
  padding: 10px;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.add-btn {
  padding: 8px 16px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.add-btn:hover {
  background: rgba(0, 97, 138, 1);
}
.cancel-btn {
  padding: 8px 16px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.cancel-btn:hover {
  background: #c0392b;
}

/* Loading and Error Messages */
.loading-message {
  text-align: center;
  padding: 20px;
  color: #3498db;
  font-style: italic;
}

.error-message {
  text-align: center;
  padding: 20px;
  color: #e74c3c;
  background: rgba(231, 76, 60, 0.1);
  border-radius: 8px;
  margin: 10px;
}
.modal-input {
  width: 90%;
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 12px;  /* rounded corners */
  outline: none;
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  margin-bottom: 20px;
}

.modal-input:focus {
  border-color: #3498db;
  box-shadow: 0 0 5px rgba(52, 152, 219, 0.4);
}
.popup {
  position: fixed;
  top: 20px;
  right: 10%;
  background: rgba(0, 97, 138, 1);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  transition: opacity 0.3s ease-in-out;
  z-index: 3000;
}
.popup.error {
  background: #e74c3c;
  color: white;
}
.popup.info {
  background: rgba(0, 97, 138, 1);
  color: white;
}

.kibana-iframe-wrapper {
  width: 100%;
  height: 85vh;
  margin-top: 20px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 12px rgba(0,0,0,0.2);
}

.kibana-iframe-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
}


</style>